import { Controller } from "@hotwired/stimulus"
import { show_error } from "lib/helpers"

// account-managements--features on accounts management edit form (feature flags section).
export default class extends Controller {
  static targets = ["featureSelect", "addFeatureButton", "featureList"]

  static values = {
    enableUrl: String,
  }

  connect() {
    this.element.addEventListener("click", this.boundDisableFeature)
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundDisableFeature)
    if (this.hasAddFeatureButtonTarget) {
      $(this.addFeatureButtonTarget).off(".accountManagementsFeatures")
    }
  }

  enableFeature(event) {
    event.preventDefault()
    const featureFlag = this.featureSelectTarget.options[this.featureSelectTarget.selectedIndex]

    $.ajax({
      url: this.enableUrlValue,
      method: "POST",
      dataType: "json",
      data: { feature_flag_id: featureFlag.value },
      success: (response) => {
        if (response.success) {
          this.#addFeatureToList(response.id, response.url, response.name)
          featureFlag.remove()
          this.#resetHint()
        } else {
          show_error(response.message)
        }
      },
    })
  }

  boundDisableFeature = (event) => {
    const button = event.target.closest(".disable-feature")
    if (!button || !this.element.contains(button)) return

    event.preventDefault()
    event.stopPropagation()

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(button.dataset.url, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
        ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
      },
      credentials: "same-origin",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          document.getElementById(`account-feature-${data.id}`)?.remove()
          this.#resetHint()
          $("#feature_flags").append(new Option(data.name, data.feature_flag_id))
        }
      })
  }

  #addFeatureToList(id, url, name) {
    const li = document.createElement("li")
    li.id = `account-feature-${id}`
    li.className =
      "list-group-item d-flex justify-content-between align-items-center"
    li.innerHTML =
      `${name}<button type="button" class="disable-feature icon-trash2" data-url="${url}" aria-label="Remove"></button>`
    this.featureListTarget.appendChild(li)
  }

  #resetHint() {
    const items = this.featureListTarget.querySelectorAll('li[id*="account-feature-"]')
    if (items.length === 0) {
      if (this.featureListTarget.querySelector(".account-feature-list-hint")) return
      const li = document.createElement("li")
      li.className =
        "list-group-item d-flex justify-content-between align-items-center msginqueue account-feature-list-hint"
      li.textContent = 'Press "Add" button to enable feature for the current account'
      this.featureListTarget.appendChild(li)
    } else {
      this.featureListTarget.querySelector(".account-feature-list-hint")?.remove()
    }
  }
}
